import * as React from 'react';
import NewTrackerModal from '../../../NewTrackerModal';
import { Card } from '../../../ui';
import { Group } from '../types';
import TrackerToggle from './TrackerToggle';
import { sortBy } from 'lodash';

interface GroupTrackersProps {
  group: Group;
  userCanAdmin: boolean;
}

const GroupTrackers: React.FC<GroupTrackersProps> = ({ group, userCanAdmin }) => {
  const [showNewModal, setShowNewModal] = React.useState(false);

  const trackersByName = sortBy(group.trackers, 'name');

  return (
    <Card className="pa4 mb2">
      <div className="flex justify-between">
        <h2 className="f5 fw6 mv0">Trackers</h2>
        {userCanAdmin && (
          <button
            className="f7 blue hover-navy pointer"
            data-testid="new-tracker-button"
            onClick={() => setShowNewModal(true)}
          >
            New Tracker
          </button>
        )}
      </div>

      {trackersByName.length > 0 && (
        <ul className="list pa0 mb0" data-testid="trackers-list">
          {trackersByName.map(tracker => (
            <TrackerToggle key={tracker.id} tracker={tracker} userCanAdmin={userCanAdmin} />
          ))}
        </ul>
      )}

      {trackersByName.length === 0 && (
        <ul className="list pa0 mb0" data-testid="trackers-list-empty">
          <li className="i moon-gray flex justify-between items-center f6 serif lh-copy bt b--light-gray pv2">
            You don&rsquo;t have any trackers yet.
          </li>
        </ul>
      )}

      {showNewModal && <NewTrackerModal closeModal={() => setShowNewModal(false)} group={group} />}
    </Card>
  );
};

export default GroupTrackers;
